import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import * as importConstant from './constants'
import * as importAction from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function listNCCRequestApi(formData) {
  const request = axiosApi().post(
    importConstant.IMPORT_REPORT_NCC_API,
    formData
  )

  return handleRequest(request);
}
function* importReportNccRequestFlow(action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listNCCRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(importAction.importReportNhaCCSuccess(results.data))

  } catch (error) {
    yield put(importAction.importReportNhaCCError(error))
  }
}

function listKhoRequestApi(formData) {
  const request = axiosApi().post(
    importConstant.IMPORT_REPORT_KHO_API,
    formData
  )

  return handleRequest(request);
}
function* importReportKhoRequestFlow(action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listKhoRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(importAction.importReportKhoSuccess(results.data))

  } catch (error) {
    yield put(importAction.importReportKhoError(error))
  }
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    importConstant.IMPORT_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* importReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(importAction.importReportListSuccess(results.data))

  } catch (error) {
    yield put(importAction.importReportListError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = importConstant.IMPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ncc=" + formData.listNcc + "&tt=" + formData.trangThai + "&kho=" + formData.listKho + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(importAction.importExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(importAction.importExportXlsError(error))
  }
}

function* importReportWatcher() {
  yield [
    takeLatest(importConstant.IMPORT_REPORT_NCC_REQUESTING, importReportNccRequestFlow),
    takeLatest(importConstant.IMPORT_REPORT_KHO_REQUESTING, importReportKhoRequestFlow),
    takeLatest(importConstant.IMPORT_REPORT_LIST_REQUESTING, importReportListRequestFlow),
    takeLatest(importConstant.IMPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
  ]
}

export default importReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/ImportReport/sagas.js